export const pkr = (n) => `PKR ${Number(n || 0).toLocaleString("en-PK")}`;

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const ORDER_STATUS = {
  submitted: { label: "Submitted", tone: "blue" },
  confirmed: { label: "Confirmed", tone: "blue" },
  payment_pending: { label: "Payment Pending", tone: "amber" },
  paid: { label: "Paid", tone: "teal" },
  processing: { label: "Processing", tone: "blue" },
  shipped: { label: "Shipped", tone: "blue" },
  delivered: { label: "Delivered / Fulfilled", tone: "teal" },
  completed: { label: "Completed", tone: "green" },
  cancelled: { label: "Cancelled", tone: "red" },
  refunded: { label: "Returned / Refunded", tone: "red" },
};

export const COMMISSION_STATUS = {
  pending: { label: "Pending", tone: "amber" },
  eligible: { label: "Eligible for review", tone: "blue" },
  approved: { label: "Approved / Payable", tone: "green" },
  paid: { label: "Paid", tone: "navy" },
  rejected: { label: "Rejected", tone: "red" },
  reversed: { label: "Reversed", tone: "red" },
};

export const DEAL_STATUS = {
  draft: { label: "Draft", tone: "gray" },
  published: { label: "Published", tone: "green" },
  archived: { label: "Archived", tone: "red" },
};

export const AVAILABILITY = {
  in_stock: "In stock",
  limited: "Limited stock",
  out_of_stock: "Out of stock",
  on_request: "Available on request",
};

export const PAY_METHODS = {
  bank_transfer: "Bank transfer",
  easypaisa: "Easypaisa",
  jazzcash: "JazzCash",
  cash: "Cash",
  cheque: "Cheque",
  other: "Other",
};

export const commissionText = (d) =>
  d.commission_type === "fixed" ? pkr(d.commission_value) : `${d.commission_value}% of order`;

export const commissionPerUnit = (d) =>
  d.commission_type === "fixed" ? d.commission_value : Math.round((d.price * d.commission_value) / 100);
